<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	<div class="">
      <el-form inline ref="form" :model="searchform">


       


      

        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value2" :placeholder="$t('searchText.상태선택')" size="mini" style="width:90px" >
               <el-option
                      v-for="item in searchform.searchOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:120px" ></el-input>
          </el-form-item>
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
       
     
    
      
        
    </div>
	<div class="d-flex align-items-center mt-2">
		
		
       <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;margin-left: 8px;" class="mr-2"></el-input>
      <el-button type="danger" size="mini" @click="deleteAll2">{{$t('searchText.선택삭제')}}</el-button>
   <div class="text-muted ml-2"><span class="text-danger mr-2">{{$t('msg.경기전')}}:{{formatMoney(buy_good0)}}</span>|<span class="text-primary ml-2 mr-2">{{$t('msg.전금액')}}:{{formatMoney(buy_good0_sum)}}</span>|<span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}} ({{$t('nav.단')}}:{{formatMoney(total_money_d)}} {{$t('nav.조')}}:{{formatMoney(total_money_z)}})</span>|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}} ({{$t('nav.단')}}:{{formatMoney(total_emoney_d)}} {{$t('nav.조')}}:{{formatMoney(total_emoney_z)}})</span>|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}} ({{$t('nav.단')}}:{{formatMoney(minus_d)}} {{$t('nav.조')}}:{{formatMoney(minus_z)}})</span></div>
		
	
	</div>
   

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
    <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
       
      

       <el-table-column
        :label="$t('msg.회차')"
         prop="buy_num" align="center">


          <template slot-scope="scope">
          {{scope.row.game_type ? scope.row.game_type:""}} {{scope.row.buy_num}}
        </template>

      </el-table-column>


      <el-table-column
         :label="$t('searchText.구분')"
        prop="buy_gubun" align="center">
        <template slot-scope="scope">
       
         {{game_codes[scope.row.game_code]}}{{scope.row.buy_gubun}}
       
        </template>

      </el-table-column>
      


       <el-table-column
        :label="$t('nav.배팅금액')"
         prop="buy_money" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.buy_money)}}</template>

      </el-table-column>

      <el-table-column
        v-if="this.outbet==='1'"
          :label="$t('msg.바치기')"
       prop="buy_money" align="center">
        <template slot-scope="scope">{{ scope.row.gn_p}}</template>

      </el-table-column>

       <el-table-column
         :label="$t('msg.배당')"
        prop="buy_bedang" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.buy_bedang)}}</template>

      </el-table-column>


       <el-table-column
         :label="$t('nav.당첨금액')"
         prop="buy_emoney" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.buy_emoney)}}</template>

      </el-table-column>
     
      <el-table-column
        :label="$t('tableText.상태')"
        prop="buy_good" align="center" width="100">
         <template slot-scope="scope">
          <span v-if="scope.row.buy_good === '0'" class="text-primary">{{$t('msg.경기전')}}</span>
          <span v-if="scope.row.buy_good === '1'" class="text-danger">{{$t('msg.적중')}}</span>
          <span v-if="scope.row.buy_good === '2'">{{$t('msg.비적중')}}</span>
          <span v-if="scope.row.buy_good === '5'" class="text-success">{{$t('msg.환불')}}</span>

        </template>
      </el-table-column>

     


     
     
     
       <el-table-column
         :label="$t('searchText.구매시간')"
       prop="buy_time" align="center">
        <template slot-scope="scope">{{ scope.row.buy_time}}</template>
      </el-table-column>
       
       <el-table-column
         :label="$t('tableText.잔액')"
         prop="ocs" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.ocs)}}</template>
      </el-table-column>
     
       
      
      
		
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        
         <el-dialog
            :visible.sync="dialogVisible" :width="memWidth" :close-on-click-modal ="false">
            <div class="mb-1">
      <el-form inline ref="form" :model="searchform">


        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value4" :placeholder="$t('tableText.타입')" size="mini"  style="width:120px" >
               <el-option
                      v-for="item in searchform.searchOptions4"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value3" :placeholder="$t('searchText.구분')" size="mini"  style="width:120px" >
               <el-option
                      v-for="item in searchform.searchOptions3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value2" :placeholder="$t('searchText.상태선택')" size="mini" style="width:90px" >
               <el-option
                      v-for="item in searchform.searchOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value"  :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions_id"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:120px" ></el-input>
          </el-form-item>
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchModel()">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
  
    </div>
     <div class="text-muted ml-2"><span class="text-danger mr-2">{{$t('msg.경기전')}}:{{formatMoney(buy_good0_id)}}</span>|<span class="text-primary ml-2 mr-2">{{$t('msg.전금액')}}:{{formatMoney(buy_good0_sum_id)}}</span>|<span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money_id)}}</span>|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney_id)}}</span>|<span class="text-danger ml-2 mr-2">{{$t('searchText.차액')}}:{{formatMoney(minus_id)}}</span>|<span class=" ml-2 mr-2">{{$t('searchText.단폴')}}:{{formatMoney(dan_id)}}</span>|<span class="ml-2 mr-2">{{$t('msg.조합')}}:{{formatMoney(zo_id)}}</span></div>
            <el-table
                :data="orderIdData"
                style="width: 100%" v-loading="mloading">
                 <el-table-column width="50" align="center" label="ID">

                    <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
                  </el-table-column>
                <el-table-column  
                  :label="$t('tableText.이름')" prop="mem_name" align="center">
                </el-table-column>
                 <el-table-column
                 :label="$t('msg.아이디')"
                 prop="mem_id" align="center" width="100"> 
                </el-table-column>
            
                   
                 <el-table-column
                  :label="$t('msg.회차')"
                 prop="buy_num" align="center">


                    <template slot-scope="scope">
                    {{scope.row.game_type ? scope.row.game_type:""}} {{scope.row.buy_num}}
                  </template>

                </el-table-column>
                  <el-table-column
                   :label="$t('searchText.구분')"
        
                  prop="buy_gubun" align="center" width="120">
                  <template slot-scope="scope">
                  
                   {{game_codes[scope.row.game_code]}}{{scope.row.buy_gubun}}
                 
                  </template>

                </el-table-column>


                 <el-table-column
                  :label="$t('nav.배팅금액')"
                  prop="buy_money" align="center">
                  <template slot-scope="scope">{{ formatMoney(scope.row.buy_money)}}</template>

                </el-table-column>

                <el-table-column
                 :label="$t('nav.바치기')"
                  v-if="this.outbet==='1'"
                  prop="buy_money" align="center">
                  <template slot-scope="scope">{{ scope.row.gn_p}}</template>

                </el-table-column>

                 <el-table-column
                  :label="$t('msg.배당')"
                  prop="buy_bedang" align="center">
                  <template slot-scope="scope">{{ formatMoney(scope.row.buy_bedang)}}</template>

                </el-table-column>


                 <el-table-column
                   :label="$t('nav.당첨금액')"
                  prop="buy_emoney" align="center">
                  <template slot-scope="scope">{{ formatMoney(scope.row.buy_emoney)}}</template>

                </el-table-column>
                <el-table-column
                  :label="$t('tableText.상태')"
                  prop="buy_good" align="center" width="100">
                   <template slot-scope="scope">
                    <span v-if="scope.row.buy_good === '0'" class="text-primary">{{$t('msg.경기전')}}</span>
                    <span v-if="scope.row.buy_good === '1'" class="text-danger">{{$t('msg.적중')}}</span>
                    <span v-if="scope.row.buy_good === '2'">{{$t('msg.비적중')}}</span>
                    <span v-if="scope.row.buy_good === '5'" class="text-success">{{$t('msg.환불')}}</span>

                  </template>
                </el-table-column>
             

                 <el-table-column
                   :label="$t('tableText.아이피')"
                   prop="buy_ip" align="center">
                </el-table-column>
                 <el-table-column
                   :label="$t('searchText.구매시간')"
                  prop="buy_time" align="center">
                  <template slot-scope="scope">{{ scope.row.buy_time.substring(8,19)}}</template>
                </el-table-column>
              
              </el-table>
               <div style="flex: 1;" class="px-2">
                      <el-pagination
                      :current-page="mcurrentPage"
                      :page-sizes="[5, 10, 15, 20]"
                      :page-size="msize"
                      layout="prev, pager, next"
                      :total="mtotal"
                      @size-change="mhandleSizeChange"
                      @current-change="mhandleCurrentChange">
                    </el-pagination>
                  </div>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">Close</el-button>
        
            </span>
          </el-dialog>
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
import layerNew from '../../components/common/layer-new.vue';
    export default {
     components: {
      layer,layerNew
    },
    	data(){
    		return{
          orderIdData:[],
          memWidth:'1200px',
          otp:'',
          mem_id:'',
          dialogVisible:false,
          disabled:false,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          outbet:window.sessionStorage.getItem('outbet'),
          bg:window.sessionStorage.getItem('bg'),
          userid:window.sessionStorage.getItem('userid'),
          aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
    		  buy_good0:'',
          buy_good0_sum:'',
          total_emoney:'',
          total_money:'',

          total_emoney_d:'',
          total_money_d:'',

          total_emoney_z:'',
          total_money_z:'',

           buy_good0_id:'',
          buy_good0_sum_id:'',
          total_emoney_id:'',
          total_money_id:'',
          dan_id:'',
          zo_id:'',


          game_codes:{

              'PWB_NB_MIX':this.$i18n.t("msg.일반조합"),
              'PWB_PB_MIX':this.$i18n.t("msg.파워조합"),
              'PWB_NBPB_MIX':'',
              'PWB':'',
              'PWB_NBPB_MIX3':'',             
            },
    		options: [{
                label: this.$i18n.t("msg.대기"),
                value: '1',
               
              }, {
                label: this.$i18n.t("msg.처리중"),
                 value: '2',
                
              }, {
                label: this.$i18n.t("msg.완료"),
                 value: '3',
               
              }, {
                label: this.$i18n.t("msg.취소"),
                 value: '4',
               
              }], 
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[ 
            {
              label:this.$i18n.t("msg.회차"),
              value:'buy_num'
            }
		        ],

            searchOptions_id:[
                
            
          
            {
             label:this.$i18n.t("msg.회차"),
              value:'buy_num'
            },
            
           

            ],

		        searchOptions2:[
                
    			{
              label:this.$i18n.t("msg.전체"),
              value:''
            },{
              label:this.$i18n.t("msg.적중"),
              value:'1'
            },
            
            {
              label:this.$i18n.t("msg.비적중"),
              value:'2'
            },
             {
              label:this.$i18n.t("msg.적특"),
              value:'3'
            },
            {
              label:this.$i18n.t("msg.경기전"),
              value:'0'
            },
            {
              label:this.$i18n.t("msg.환불"),
              value:'5'
            },
		        ],
            searchOptions3:[
           {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.파워볼"),
              value:'PWB'
            },
            {
              label:this.$i18n.t("msg.일반볼조합"),
              value:'PWB_NB_MIX'
            },
            {
              label:this.$i18n.t("msg.파워볼조합"),
              value:'PWB_PB_MIX'
            },
            {
              label:this.$i18n.t("msg.파워일반조합"),
              value:'PWB_NBPB_MIX'
            },
            {
              label:this.$i18n.t("msg.모든조합"),
              value:'mix'
            }
            ],
             searchOptions4:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.동행"),
              value:'lotte'
            },
            {
              label:'EOS',
              value:'eos'
            },
            {
              label:this.$i18n.t("msg.보글"),
              value:'bg'
            },
            
            ],
		        value:'',
		        value2:'',
            value3:'',
            value4:'',


    			},
    			 pickerOptions: {
    			},
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
        valueOption:'아이디',
    			
		        
    		
		    		 total:0,
		    		 size:0,
                      mtotal:0,
                     msize:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
                     mloading:false,
		    		 tableData: [],
			         currentPage:1,
                     mcurrentPage:1,
			         multipleSelection:[],
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    computed:{
      minus(){
        return this.total_money - this.total_emoney
      },
      minus_d(){
        return this.total_money_d - this.total_emoney_d
      },
      minus_z(){
        return this.total_money_z - this.total_emoney_z
      },
      minus_id(){
        return this.total_money_id - this.total_emoney_id
      }

    },
    	
    	methods:{
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              this.currentPage=1;
            


    			this.getList();
    			
             

    		},
        searchModel(){
          this.getorderData();
        },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
                  mhandleSizeChange(val) {
                    //console.log(`每页 ${val} 条`);
                    this.msize = val
                    this.getorderData();
                   

                  },
                  mhandleCurrentChange(val) {
                    //console.log(`当前页: ${val}`);
                    this.mcurrentPage = val
                    this.getorderData();
                   
                  },
			     handleSelectionChange(val) {
          console.log(val)
                this.multipleSelection = val;

      },
      openNewModel(e){
        this.dialogVisible = true
        this.mem_id=e.row.mem_id
        this.getorderData()

      },
      getorderData(){
        this.mloading = true
        let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }
         let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/betlist_api?mem_id='+this.mem_id+'&game_type='+this.searchform.value4+'&game_code='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.mcurrentPage;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('data=',response.data.data.total)
                     let item = response.data.data
                    this.orderIdData =item.data
                     this.mtotal = response.data.data.total

                     this.mcurrentPage = response.data.data.current_page
                     this.msize = response.data.data.per_page
                    this.buy_good0_id = response.data.buy_good0
                     this.buy_good0_sum_id = response.data.buy_good0_sum
                     this.total_emoney_id = response.data.total_emoney
                     this.total_money_id = response.data.total_money

                     this.dan_id = response.data.dan
                     this.zo_id = response.data.zo
                     
                     
                    
                     this.mloading = false



                   
               
            }).catch((error) =>{
              // if(error.response.status==401)
              // {
              //   this.$router.push({name:'login'})

              // }
                console.log('error',error.response)       //请求失败返回的数据
               
            })
      },
       openModel(id){

        if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['950px', '680px'],
             
             });
              return;
           }
           
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        }, 
       deleteAll2(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까복구불가"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/betout_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },   
    		getList(){

    		

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/betlist_api?game_type='+this.searchform.value4+'&game_code='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                  
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.buy_good0 = response.data.buy_good0
                     this.buy_good0_sum = response.data.buy_good0_sum
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money

                       this.total_emoney_d = response.data.total_emoney_d
                     this.total_money_d = response.data.total_money_d

                       this.total_emoney_z = response.data.total_emoney_z
                     this.total_money_z = response.data.total_money_z


                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
              this.loading = false
               
            })
    		},
    	
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

</style>


// WEBPACK FOOTER //
// src/views/orderoffer/list.vue